import React, { FunctionComponent } from 'react';
import dynamic from 'next/dynamic';
import {
  IframeWrapper,
  Maps,
  MapsType,
} from '@doveit/lego';
import useNextConfig from '../../../../hooks/useNextConfig/useNextConfig';
import { toGalleryImages } from '../../../../utils/property/image';
import { GallerySectionItem } from '../constants';
import { PropertyImage } from '../../../../../services/dtos/property';

const Gallery = dynamic(() => import('../../../../components/gallery/Gallery'), {
  ssr: false,
});

export interface GalleryModalContentProps {
  item: GallerySectionItem,
  images?: PropertyImage[],
  blueprints?: PropertyImage[],
  virtualTourSrc?: string,
  videoSrc?: string,
  normalizedAddress?: string,
  coordinates?: string,
}

export const GalleryModalContent: FunctionComponent<GalleryModalContentProps> = ({
  item,
  virtualTourSrc,
  videoSrc,
  normalizedAddress,
  images = [],
  blueprints = [],
  coordinates,
}) => {
  const { MAPS } = useNextConfig();

  if (images.length && item === GallerySectionItem.GALLERY) {
    return (
      <Gallery
        items={toGalleryImages(images, 'Foto')}
        fit
        lazyLoad
      />
    );
  }

  if (virtualTourSrc && item === GallerySectionItem.VIRTUAL_TOUR) {
    return (
      <IframeWrapper
        src={virtualTourSrc}
        title="Virtual tour"
        data-ref="virtual-tour"
        fit
      />
    );
  }

  if (videoSrc && item === GallerySectionItem.VIDEO) {
    return (
      <IframeWrapper
        src={videoSrc}
        title="Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        data-ref="video"
        fit
      />
    );
  }

  if (normalizedAddress && item === GallerySectionItem.MAP) {
    return (
      <Maps
        apiKey={MAPS.apiKey}
        title="Mappa"
        params={normalizedAddress}
        fit
      />
    );
  }

  if (blueprints.length && item === GallerySectionItem.BLUEPRINTS) {
    return (
      <Gallery
        items={toGalleryImages(blueprints, 'Planimetria')}
        fit
        lazyLoad
      />
    );
  }

  if (coordinates && item === GallerySectionItem.STREET_VIEW) {
    return (
      <Maps
        apiKey={MAPS.apiKey}
        title="Mappa virtuale"
        type={MapsType.STREETVIEW}
        params={coordinates}
        fit
      />
    );
  }

  return null;
};

export default GalleryModalContent;
